export const BULK_ASSIGN_ORGANIZATION_KEY = 'BULK_ASSIGN_ORGANIZATION';
export const BULK_ASSIGN_LOCATION_KEY = 'BULK_ASSIGN_LOCATION';
export const ORGANIZATION_KEY = 'ORGANIZATION';
export const LOCATION_KEY = 'LOCATION';
export const MODAL_TYPES = {
  ORGANIZATION: 'ORGANIZATION',
  LOCATION: 'LOCATION',
};
